import CustomTitle from "@/components/custom_title";
import Layout from "@/locales/en/layout/Layout";
import React from "react";
import {useTranslation} from "react-i18next";
import video from "../../../assets/kelajaka_qadam.mp4"

const M7 = () => {

    const {t} = useTranslation();

    document.title = t("header.header__sub__menu.menu-1.item-7")
    return (
        <>
            <Layout>
                <CustomTitle name={t("header.header__sub__menu.menu-1.item-7")}/>

                <div className="container">
                    <h1 className="text-center">Biz haqimizda</h1>
                    <p className="text-center" style={{fontSize: "25px"}}>“Kelajakka Qadam Markazi - Smart akademiyasi”
                        zamonaviy ta’lim markazi bo‘lib,
                        universitet qoshida faoliyat yuritadi. Markazning asosiy maqsadi –
                        yoshlarni raqamli bilimlar, zamonaviy texnologiyalar va innovatsion g‘oyalar bilan
                        qurollantirish.
                    </p>
                </div>
                <CustomTitle name=""/>
                <div className="container">
                    <h1 className="text-center">Video qo'llanmalar</h1>
                    <div className="row">
                        <div className="col-md-3 my-3">
                            <div className="border rounded overflow-hidden p-2">
                                <div className="ratio ratio-16x9">
                                    <iframe width="1296" height="729" src="https://www.youtube.com/embed/bHwXd5lY_R8"
                                            title="Kelajakka Qadam: Yangi Hamkorliklar Sari!" frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                                </div>
                                <h4 className="mb-3">Kelajakka Qadam: Yangi Hamkorliklar Sari!</h4>
                                <p>
                                    "Kelajakka Qadam" dasturi doirasida yurtimizdagi yetakchi universitetlar bilan
                                    hamkorlik
                                    shartnomalarini imzolandi.
                                </p>
                            </div>

                        </div>
                        <div className="col-md-3 my-3">
                            <div className="border rounded overflow-hidden p-2">
                                <div className="ratio ratio-16x9">
                                    <video src={video} controls/>

                                </div>
                                <h4 className="mb-3">Тошкент давлат техника университетида “Келажакка қадам” мавзусида
                                    семинар
                                    тренинг ўтказилди.</h4>
                            </div>

                        </div>
                        <div className="col-md-3 my-3">
                            <div className="border rounded overflow-hidden p-2">
                                <div className="ratio ratio-16x9">
                                    <iframe width="1287" height="729" src="https://www.youtube.com/embed/By4hgEmduPc"
                                            title="🎬 “Kelajakka qadam” dasturi — raqamli formatda!" frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                                </div>
                                <h4 className="mb-3">“Kelajakka qadam” dasturi — raqamli formatda!</h4>
                                <p>
                                    AI texnologiyasi yordamida tayyorlangan ushbu videoda oktyabr oyida amalga
                                    oshirilgan
                                    ishlar, tadbirlar va natijalar jamlangan.
                                </p>
                            </div>

                        </div>
                        <div className="col-md-3 my-3">
                            <div className="border rounded overflow-hidden p-2">
                                <div className="ratio ratio-16x9">
                                    <iframe width="1296" height="729" src="https://www.youtube.com/embed/5oNRk-Olxck"
                                            title="Kelajakka qadam | Talaba Expo - 2025 | Oʻzbekiston24 efirida"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                            referrerPolicy="strict-origin-when-cross-origin" allowFullScreen></iframe>
                                </div>
                                <h4 className="mb-3">Kelajakka qadam | Talaba Expo - 2025</h4>
                                <p>
                                    “Kelajakka Qadam” dasturi doirasida bitiruvchi yoshlar oʻz biznes loyihalarini
                                    taqdim etdi.
                                    Bu ilhomli daqiqalar Oʻzbekiston 24 telekanalida yoritildi!
                                </p>
                            </div>

                        </div>

                    </div>
                </div>
                <CustomTitle name=""/>
                <div className="container">
                    <h1 className="text-center">Kredit xizmatlari</h1>
                    <p className="text-center" style={{fontSize: "25px"}}>
                        💡 Biznes g‘oya bor, lekin mablag‘ yo‘qmi ? <span className="text-danger"> “KELAJAKKA QADAM” </span>bu muammoni yechadi!
                    </p>
                    <div className="row g-4 mt-3">
                        <div className="col-md-4">
                            <div className="card  h-100 course-card p-4 shadow-sm text-center">
                                <div className="icon mb-3">
                                    <i className="fas fa-graduation-cap"></i>
                                </div>
                                <h5 className="card-title mt-2">Kelajakka birinchi qadam</h5>
                                <p className="card-text">
                                    Ijtimoiy soliq to'lab,o'zini-o'zi band qilgan bitiruvchilar uchun
                                </p>
                                <a target="_blank" href="https://nbu.uz/kichik-biznes/kreditlar/yangi-kelajakka-qadam-kreditlari" className="btn btn-success mt-3">Batafsil</a>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card h-100 course-card p-4 shadow-sm text-center">
                                <div className="icon mb-3">
                                    <i className="fas fa-lightbulb"></i>
                                </div>
                                <h5 className="card-title mt-2">Kelajak uchun start</h5>
                                <p className="card-text">
                                    Yakka tartibdagi tadbirkorlar yoki yuridik shaxs tashkil etgan bitiruvchilar uchun
                                </p>
                                <a target="_blank" href="https://nbu.uz/kichik-biznes/kreditlar/yangi-kelajakka-qadam-kreditlari" className="btn btn-success mt-3">Batafsil</a>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card  h-100 p-4 shadow-sm text-center">
                                <div className="icon mb-3">
                                    <i className="fas fa-project-diagram"></i>
                                </div>
                                <h5 className="card-title mt-2">Yorqin kelajak sari</h5>
                                <p className="card-text">
                                    Yakka tartibdagi tadbirkorlar yoki yuridik shaxs tashkil etgan bitiruvchilar uchun
                                </p>
                                <a target="_blank" href="https://nbu.uz/kichik-biznes/kreditlar/yangi-kelajakka-qadam-kreditlari" className="btn btn-success mt-3">Batafsil</a>
                            </div>
                        </div>
                    </div>
                </div>

                <CustomTitle name=""/>


                <div className="container">
                    <h3 className="text-center mb-5 fw-bold">Kredit olish tartibi</h3>

                    <div className="row g-4">

                        <div className="col-md-4">
                            <div className="card p-4 text-center h-100 shadow-sm">
                                <div style={{width:"55px", height:"55px"}}
                                     className="d-flex align-items-center justify-content-center step-number
                                      mx-auto mb-3 bg-success rounded-circle text-white">
                                    1
                                </div>
                                <h5 className="mb-2">Ariza topshirish</h5>
                                <p>Kerakli hujjatlar bilan " Kelajakka qadam " markaziga murojaat qilishingiz mumkin.</p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card p-4 text-center h-100 shadow-sm">
                                <div style={{width:"55px", height:"55px"}}
                                     className="d-flex align-items-center justify-content-center step-number
                                      mx-auto mb-3 bg-success rounded-circle text-white">
                                    2
                                </div>                                <h5 className="mb-2">Hujjatlarni ko‘rib chiqish</h5>
                                <p>Mutaxassislar tomonidan hujjatlar tekshiriladi va baholanadi.</p>
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div className="card p-4 text-center h-100 shadow-sm">
                                <div style={{width:"55px", height:"55px"}}
                                     className="d-flex align-items-center justify-content-center step-number
                                      mx-auto mb-3 bg-success rounded-circle text-white">
                                    3
                                </div>
                                <h5 className="mb-2">Tasdiqlash</h5>
                                <p>Loyiha yoki o‘quv dasturi moliyalashtirishga loyiq deb topiladi.</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="card p-4 text-center h-100 shadow-sm">
                                <div style={{width:"55px", height:"55px"}}
                                     className="d-flex align-items-center justify-content-center step-number
                                      mx-auto mb-3 bg-success rounded-circle text-white">
                                    4
                                </div>
                                <h5 className="mb-2">Kredit ajratilishi</h5>
                                <p>Bank orqali mablag‘ o‘tkaziladi va sizga xabar beriladi.</p>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="card step-card p-4 text-center h-100 shadow-sm">
                                <div style={{width:"55px", height:"55px"}}
                                     className="d-flex align-items-center justify-content-center step-number
                                      mx-auto mb-3 bg-success rounded-circle text-white">
                                    5
                                </div>
                                <h5 className="mb-2">Monitoring</h5>
                                <p>Loyihaning bajarilishi va mablag‘dan foydalanish nazorati olib boriladi.</p>
                            </div>
                        </div>

                    </div>
                </div>


            </Layout>
        </>
    )
        ;
};

export default M7;
